import { MethodEnum } from '@enum/method.enum';
import { isString } from '@util/data/is-exist';

const rubyMethods = {
  [MethodEnum.GET]: 'Get',
  [MethodEnum.POST]: 'Post',
  [MethodEnum.PUT]: 'Put',
  [MethodEnum.PATCH]: 'Patch',
  [MethodEnum.DELETE]: 'Delete',
};

export const rubyTemplate = (
  link: string,
  headers: Record<string, string> = {},
  body: Record<string, string> = {},
  method: MethodEnum = MethodEnum.GET,
) => {
  const headersText = Object.entries(headers)
    .filter(([, value]) => isString(value))
    .map(([key, value]) => `request["${key}"] = "${value}"`);

  return `require "uri"
require "json"
require "net/http"

url = URI("${encodeURI(link)}")

https = Net::HTTP.new(url.host, url.port)
https.use_ssl = true

request = Net::HTTP::${rubyMethods[method]}.new(url)
${headersText.length > 0 ? `${headersText.join(',\n')}\n` : ''}
request.body = JSON.dump(${JSON.stringify(body, null, '\t')})

response = https.request(request)
puts response.read_body`;
};
